import { _ } from "@icc/shared/helpers";

export interface ComplaintSparePart {
    /**
     * Numer porządkowy
     */
    id?: number;

    /**
     * Unikalny numer w formacie UUID v4
     */
    uuid: string;

    /**
     * Id produktu (części zamiennej)
     */
    productId: number;

    /**
     * Nazwa produktu
     */
    name?: string;

    /**
     * Ilość
     */
    quantity: number;

    /**
     * Id dodatkowej jednostki miary
     */
    unitId?: number;

    /**
     * Kod wbudowanej jednostki miary
     */
    unitCode?: string;

    /**
     * Uuid dokumentu
     */
    documentId: string;

    /**
     * Czy część została usunięta
     */
    isDeleted?: boolean;

    /**
     * Czas utworzenia
     */
    created?: Date;

    /**
     * Czas modyfikacji
     */
    modified?: Date;

    /**
     * Czas utworzenia na serwerze
     */
    createdServer?: Date;

    /**
     * Czas modyfikacji na serwerze
     */
    modifiedServer?: Date;

    /**
     * Czas usunięcia
     */
    deletedAt?: Date;

    /**
     * Identyfikator klienta (przeglądarki), w którym powstała część zamienna
     */
    machineId?: string;

    /**
     * Czy oczekuje na zapis
     */
    $dirty?: boolean;

    /**
     * Id firmy
     */
    companyId?: number | null;
}

export interface ComplaintSparePartRequestParams {
    userId: number;
    appVersion: string;
}

export type ComplaintSparePartDTO = Omit<
    ComplaintSparePart,
    'createdServer' | '$dirty'
    >;

export const ComplaintSparePartNonReadableProps = [
    'id',
    'uuid',
    'documentId',
    'created',
    'modified',
    'createdServer',
    'modifiedServer',
    'deletedAt',
    'machineId',
    '$dirty',
    'companyId',
] as const satisfies readonly (keyof ComplaintSparePart)[];

export const ComplaintSparePartReadablePropsNames: Record<Exclude<keyof ComplaintSparePart, typeof ComplaintSparePartNonReadableProps[number]>, string> = {
    isDeleted: _('COMPLAINT_SPARE_PART|Usunięta'),
    productId: _('COMPLAINT_SPARE_PART|Produkt'),
    name: _('COMPLAINT_SPARE_PART|Nazwa produktu'),
    quantity: _('COMPLAINT_SPARE_PART|Ilość'),
    unitId: _('COMPLAINT_SPARE_PART|Jednostka miary'),
    unitCode: _('COMPLAINT_SPARE_PART|Jednostka miary'),
};
